import { render } from "./etDesignApiShow.vue?vue&type=template&id=052e7f35"
import script from "./etDesignApiShow.vue?vue&type=script&lang=js"
export * from "./etDesignApiShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__